import { useSelector } from "react-redux";
import { assetSelectors } from "../ducks/asset";

export const useAsset = () => {
  const showSms = useSelector(assetSelectors.showSms);

  const baseDir = window.location.href.substring(
    0,
    window.location.href.indexOf("/#/"),
  );

  return { showSms, baseDir };
};
